import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function AccesoALaLanding() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h5 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>ACCESO Y USO DE LA LANDING CORP</h5>
          <br></br>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>
                <strong>Ingreso a la Landing:</strong> El Cliente Corporativo deberá acceder a la Landing Corp a través de la página web <a href="https://www.parking.net.co/">https://www.parking.net.co/</a>. Parking se reserva el derecho de modificar la URL o dominio del Landing Corp la cual será informada previa y oportunamente al Usuario.
              </p>
            </li>
            <li>
              <p>
                <strong>Registro y Credenciales:</strong> El Cliente Corporativo deberá contar con credenciales de acceso otorgadas por Parking para gestionar sus productos dentro de la plataforma.
              </p>
            </li>
            <li>
              <p>
                <strong>Aceptación de Términos y Condiciones:</strong> Antes de acceder a los productos y servicios, el Cliente Corporativo deberá leer y aceptar los presentes T&C.
              </p>
            </li>
            <li>
              <p>
                <strong>Aceptación de la política de Tratamiento de Datos Personales:</strong> El Cliente Corporativo deberá leer y aceptar la Política de Tratamiento de Datos de la Parking, mediante la cual adquiere conocimiento sobre el uso de sus datos, los derechos que le asisten, y los canales de atención disponibles para su ejercicio.
              </p>
            </li>
            <li>
              <p>
                <strong>Inicio de Sesión:</strong> El Cliente Corporativo recibirá las credenciales para acceder a la plataforma al correo electrónico registrado.
              </p>
            </li>
            <li>
              <p>
                <strong>Cambio de Contraseña:</strong> En el primer inicio de sesión, el Usuario deberá cambiar la contraseña temporal por una de su elección.
              </p>
            </li>
            <li>
              <p>
                En su primer ingreso, deberán cambiar su contraseña temporal por una definitiva.
              </p>
            </li>
            <li>
              <p>
                <strong>Permisos y Notificaciones:</strong> Para recibir información relevante sobre sus productos y servicios, los Usuarios podrán habilitar notificaciones dentro de la plataforma.
              </p>
            </li>
            <li>
              <p>
                <strong>Acceso y Uso:</strong> Una vez registrados y autenticados, los Usuarios podrán hacer uso de la Landing Corp conforme a las condiciones establecidas en los presentes T&C.
              </p>
            </li>
            <li>
              <p>
                <strong>Gestión de Productos:</strong> El Cliente Corporativo podrá adquirir y administrar los productos contratados sin necesidad de acudir a puntos físicos.
              </p>
            </li>
            <li>
              <p>
                El Usuario es responsable de toda la actividad realizada en su cuenta y deberá mantener su información actualizada y segura. El incumplimiento de esta obligación podrá conllevar la suspensión o cancelación del acceso a la plataforma por parte de Parking.
              </p>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
}